import customHeaders, { getSpace } from '../../common/headers';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDataTable } from '../../common/hooks';
import { OlegHttps } from '../../fetchUrls';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { useState, useEffect, useRef } from 'react';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import {
  TableBox,
  DropDownSelector,
  RangeBox,
} from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import './ProductsInCampaign.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { RequestController } from '../../common/filtersFunc';
import { periodWeek } from '../../common/constant';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { msToLocalDate } from '../../common/constant';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { useSavedFilters } from '../../common/useSavedFilters';

const options_prop = [
  { label: 'Ozon', value: 1 },
  { label: 'Wildberries', value: 3 },
  { label: 'Yandex', value: 2 },
];

const ProductsInCampaign = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'products-in-campaign');
  // Реф для хранения контроллера запросов
  const requestControllerRef = useRef(new RequestController());

  const [pageValue, setPageValue] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();

  // Фильтры
  const filterConfig = [
    { key: 'mp', type: 'multi' },
    { key: 'api', type: 'multi' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'campaign', type: 'multi' },
    { key: 'date_from', type: 'date' },
    { key: 'date_to', type: 'date' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [advCampaignData, setAdvCampaignData] = useState([]);

  const [selectedMarketplace, setSelectedMarketplace] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedAdvCampaign, setSelectedAdvCampaign] = useState([{ label: 'Все', value: 'all' }]);

  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [advCampaignPage, setAdvCampaignPage] = useState(1);

  const [apiPage, setApiPage] = useState(1);
  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');
  const [advCampaignQuery, setAdvCampaignQuery] = useState('');

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)
  const [totalAdvCampaign, setTotalAdvCampaign] = useState(0)

  const [isDisabledBtn, setIsDisabledBtn] = useState(true);

  // Дата
  const [date, setDate] = useState(periodWeek())
  const [dateFrom, dateTo] = date;

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
  const [checkedProducts, setCheckedProducts] = useState([]);

  const activeTab = useParams()['*'];

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.mp) setSelectedMarketplace(urlParams.mp)
        if (urlParams.api) setSelectedApi(urlParams.api)
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.campaign) setSelectedAdvCampaign(urlParams.campaign)
        if (urlParams.date_from) {
          setDate([
            new Date(parseInt(urlParams.date_from)),
            new Date(parseInt(urlParams.date_to)),
          ]);
        }

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      mp: urlParams?.mp || selectedMarketplace,
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      campaign: urlParams?.campaign || selectedAdvCampaign,
      date_from: urlParams?.date_from || dateFrom,
      date_to: urlParams?.date_to || dateTo,
    })
  }, [isReady]);

  const fetchTableData = (params, abortController = new AbortController()) => {

    setLoading(true);

    let sort, filters;
    if (params) {
      [sort, filters] = params;
    }

    const url = `${OlegHttps}/api/v2/marketing/table/products_in_campaign_participate_items${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''
      }`;

    const [date_from, date_to] = date;

    const body = JSON.stringify({
      offer_id_list: ['all'],
      filters: filters || [],
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      api_id_list: getValueMultiFilter(selectedApi),
      campaign_id_list: getValueMultiFilter(selectedAdvCampaign),
      date_from: msToLocalDate(date_from),
      date_to: msToLocalDate(date_to),
      order_param: sort?.[0],
      order_param_direction: sort?.[1],
      page: paginatorRef.current?.page || 0,
      limit: paginatorRef.current?.limit || 10,
    });

    fetch(url, {
      method: 'POST',
      headers,
      body,
      signal: abortController.signal,
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => setTable(json))
      .catch((e) => console.error(e))
      .finally(() => {
        if (abortController?.signal.aborted) return
        setLoading(false)
      });
  };

  useEffect(() => {
    setPageValue(activeTab);
    const campaignName = searchParams.get('campaignName');
    const campaignId = searchParams.get('campaignId');
    const apiName = searchParams.get('apiName');
    const apiId = searchParams.get('apiId');
    if (
      (campaignName?.length > 0) &
      (campaignId?.length > 0) &
      (apiName?.length > 0) &
      (apiId?.length > 0)
    ) {
      setSelectedAdvCampaign([{ label: campaignName, value: campaignId }]);
      setSelectedApi([{ label: apiName, value: apiId }]);
    }
  }, [activeTab]);

  useEffect(() => {
    if (
      selectedApi.length > 0 &&
      selectedCategory.length > 0 &&
      selectedBrand.length > 0
    ) {
      setIsDisabledBtn(false);
    } else setIsDisabledBtn(true);
  }, [selectedApi, selectedCategory, selectedBrand]);

  const apiFilter = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalApi,
      page: apiPage,
      set: setApiData,
      searchParam: apiQuery,
      selectedApi,
      selectedShop: selectedMarketplace,
      setTotal: setTotalApi,
      filter: 'api_id',
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    apiFilter()
  }, [apiPage, apiQuery, isFilterRequest]);

  const categoryFilter = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalCategory,
      page: categoryPage,
      apiData,
      selectedApi,
      set: setCategoryData,
      searchParam: categoryQuery,
      setTotal: setTotalCategory,
      filter: 'category',
      dateFrom,
      dateTo
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    categoryFilter()
  }, [categoryPage, categoryQuery, date, isFilterRequest]);

  const brandFilter = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalBrand,
      selectedApi,
      selectedCategory,
      page: brandPage,
      searchParam: brandQuery,
      selectedShop: selectedMarketplace,
      set: setBrandData,
      setTotal: setTotalBrand,
      filter: 'brand',
      dateFrom,
      dateTo
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    brandFilter()
  }, [brandPage, brandQuery, date, isFilterRequest]);

  const advCampaignFilter = () => {
    const controller = requestControllerRef.current.createController('adv-campaign');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalAdvCampaign,
      selectedApi,
      selectedCategory,
      selectedBrand,
      page: advCampaignPage,
      searchParam: advCampaignQuery,
      selectedShop: selectedMarketplace,
      set: setAdvCampaignData,
      setTotal: setTotalAdvCampaign,
      filter: 'campaign_advertising',
    })?.finally(() => {
      requestControllerRef.current.removeController('adv-campaign');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    advCampaignFilter()
  }, [advCampaignPage, advCampaignQuery, isFilterRequest]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  useEffect(() => {
    if (!isReady) return;
    const abortController = new AbortController();
    fetchTableData([], abortController);
    return () => abortController.abort();
  }, [date, isTableRequest]);

  return (
    <div className="products-in-campaign">
      <TitlePage
        title='Товары в кампании'
      />

      <div className="products-in-campaign__filters">
        <FilterContainer
          loading={isSaved}
          saveFilters={saveFilters}
          clearSavedFilters={clearSavedFilters}
          hasSavedFilters={hasSavedFilters}
          onReset={(e) => {
            setSelectedMarketplace([])
            setSelectedApi([]);
            setSelectedCategory([]);
            setSelectedBrand([]);
            setSelectedAdvCampaign([])
            updateURL({
              mp: null,
              api: null,
              category: null,
              brand: null,
              campaign: null,
            });
            setIsTableRequest(!isTableRequest)
            setIsFilterRequest(!isFilterRequest)
          }}
        >
          <DropDownSelector
            options_prop={options_prop}
            state={selectedMarketplace}
            setState={setSelectedMarketplace}
            placeholder="Маркетплейс"
            total={options_prop?.length}
            multi
            onBlur={() => {
              updateURL({ mp: selectedMarketplace });
              apiFilter()
              brandFilter()
              categoryFilter()
              advCampaignFilter()
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={apiData}
            state={selectedApi}
            setState={setSelectedApi}
            placeholder="Площадка"
            total={totalApi}
            fetchCallback={setApiPage}
            setInputChange={setApiQuery}
            multi
            onBlur={() => {
              updateURL({ api: selectedApi });
              brandFilter()
              categoryFilter()
              advCampaignFilter()
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={categoryData}
            state={selectedCategory}
            setState={setSelectedCategory}
            placeholder="Категория"
            total={totalCategory}
            fetchCallback={setCategoryPage}
            setInputChange={setCategoryQuery}
            multi
            onBlur={() => {
              updateURL({ category: selectedCategory });
              brandFilter()
              advCampaignFilter()
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={brandData}
            state={selectedBrand}
            setState={setSelectedBrand}
            placeholder="Бренд"
            total={totalBrand}
            fetchCallback={setBrandPage}
            setInputChange={setBrandQuery}
            multi
            onBlur={() => {
              updateURL({ brand: selectedBrand });
              advCampaignFilter()
              setIsTableRequest(!isTableRequest)
            }}
          />
          <DropDownSelector
            options_prop={advCampaignData}
            state={selectedAdvCampaign}
            setState={setSelectedAdvCampaign}
            placeholder="Кампания"
            total={totalAdvCampaign}
            fetchCallback={setAdvCampaignPage}
            setInputChange={setAdvCampaignQuery}
            multi
            onBlur={() => {
              updateURL({ campaign: selectedAdvCampaign });
              setIsTableRequest(!isTableRequest)
            }}
          />
        </FilterContainer>

        <RangeBox
          date={date}
          setDate={(e) => {
            const [newDateFrom, newDateTo] = e;
            updateURL({
              date_from: newDateFrom,
              date_to: newDateTo
            });
            setDate(e)
          }}
        />
      </div>

      <TableBox
        {...tableProps}
        paginator={true}
        ref={paginatorRef}
        onCheck={setCheckedProducts}
        fetchCallback={fetchTableData}
      />
    </div>
  );
};

export { ProductsInCampaign };
